// extracted by css-extract-rspack-plugin
export default {"cls1":"UserCard-cls1_OMn","cls2":"UserCard-cls2_7GZ UserCard-cls1_OMn"};